import { render, staticRenderFns } from "./ChallengeUserList.vue?vue&type=template&id=5fdfa0fd&"
import script from "./ChallengeUserList.vue?vue&type=script&lang=js&"
export * from "./ChallengeUserList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports